import React, { useEffect, useState } from "react";

export default function RunningStatus({
  value = 0, // between 0–100
  color = "#F97316",
  trackColor = "#fff",
  strokeWidth = 2,
  strokeLinecap = "round",
}) {
  const radius = 5; // smaller circle
  const circumference = 2 * Math.PI * radius;
  const [animatedValue, setAnimatedValue] = useState(0);
  const normalizedValue = Math.min(Math.max(value, 0), 100);
  // Animate when value changes
  useEffect(() => {
    let start = animatedValue;
    let end = Math.min(Math.max(value, 0), 100);
    let startTime;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / 500, 1); // 500ms animation
      const current = start + (end - start) * progress;
      setAnimatedValue(current);
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [value, animatedValue]);

  const offset = circumference - (animatedValue / 100) * circumference;

  return (
    <div className="flex items-center gap-2 border-[#F973161A] text-[#E3650F] border-[1.5px] rounded-full bg-[#F973161A] w-fit px-2 py-1">
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        style={{ transform: "rotate(-90deg)" }}
      >
        {/* Track */}
        <circle
          cx="6"
          cy="6"
          r={radius}
          stroke={trackColor}
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        {/* Progress */}
        <circle
          cx="6"
          cy="6"
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap={strokeLinecap}
          style={{
            transition: "stroke-dashoffset 0.5s ease",
          }}
        />
      </svg>

      <span className="flex gap-1">
        {Math.round(normalizedValue)}% <span>Running</span>{" "}
      </span>
    </div>
  );
}
